export default function CadastroProducao() {
	return <></>;
}
